import React, { Fragment, useState, useEffect } from "react";
import { Flex } from "../../assets/ui";
import TopNav from "../TopNav";
import Banner from "../Section1_Banner";
import ExsportiaFeatures from "../Section2_ExsportiaFeatures";
import Cases from "../Section3_Cases";
import FindOpponent from "../Section3_FindOponent/info";
import VideoSection from "../Section_Video";
import VenueCalendar from "../Section5_VenueCalendar";
import VenueManagement from "../Section6_VenueManagementFeatures";
import MobileVMS from "../Section8_MobileVMS";
import TeachersTrainersBanner from "../Section9_TeachersTrainersBanner";
import TeachersTrainersCases from "../Section10_TeachersTrainersCases";
import PrivateHosting from "../Section11_PrivateHosting";
import PrivateHostingFeatures from "../Section12_PrivateHostingFeatures";
import Contact from "../Section13_Contact";
import Footer from "../Footer";
import styled from "styled-components";
import FeaturesDemoList from "../Section7_FeaturesDemoList";
import Login from "../Login";
import moment from "moment";

export const StyledIntroduceWrapper = styled.div`
  position: relative;
  background: radial-gradient(
      100% 100% at 93.55% 94.42%,
      #ffffff 0%,
      rgba(0, 0, 0, 0.5) 100%
    ),
    #233247;
  background-blend-mode: multiply, normal;
`;

const Landing = () => {
  const [showLanding, setShowLanding] = useState(false);
  const showLandingHandler = () => {
    setShowLanding(!showLanding);
  };

  const checkIfKeyExpired = () => {
    setTimeout(() => {
      const localStorage = window.localStorage;
      const keyWithDate = JSON.parse(localStorage.getItem("accessKey"));

      if (
        keyWithDate &&
        keyWithDate.expirationDate &&
        keyWithDate.expirationDate >
          moment()
            .utc()
            .valueOf()
      ) {
        checkIfKeyExpired();
        console.log("checkIfKeyExpired");
      } else {
        localStorage.removeItem("accessKey");
        setShowLanding(false);
      }
    }, 1000 * 60);
  };

  useEffect(() => {
    checkIfKeyExpired();
  }, [showLanding]);

  return (
    <Fragment>
      <StyledIntroduceWrapper>
        <Flex
          height="100vh"
          flexDirection="column"
          overflowX="hidden"
          position="relative"
        >
          <TopNav />
          <Banner />
        </Flex>
        {showLanding && <ExsportiaFeatures />}
      </StyledIntroduceWrapper>
      {showLanding ? (
        <Fragment>
          <Cases />
          <FindOpponent />
          <VideoSection video="https://firebasestorage.googleapis.com/v0/b/exsportia-dev.appspot.com/o/Exsportia-video-player.mp4?alt=media&token=a83fed2e-71c0-4f44-984f-3f9b447ce84b" />
          <VenueCalendar />
          <VenueManagement />
          <VideoSection video="https://firebasestorage.googleapis.com/v0/b/exsportia-dev.appspot.com/o/Exsportia-video-Golf.mp4?alt=media&token=9ee7a45b-9884-4cac-bdba-be74970b5784" />
          <FeaturesDemoList />
          <MobileVMS />
          <TeachersTrainersBanner />
          <TeachersTrainersCases />
          <VideoSection
            video={
              "https://firebasestorage.googleapis.com/v0/b/exsportia-dev.appspot.com/o/Exsportia-video-Dan.mp4?alt=media&token=943c4952-c1ed-4a8f-95b3-b1a5b7d63a50"
            }
          />
          <PrivateHosting />
          <PrivateHostingFeatures />
          <Contact />
          <Footer />
        </Fragment>
      ) : (
        <Login setShowLanding={showLandingHandler} />
      )}
    </Fragment>
  );
};

export default Landing;
